/** @module Enums */ /** typedoc */
var ProofOfRightsTypeEnum;
(function (ProofOfRightsTypeEnum) {
    ProofOfRightsTypeEnum["Document"] = "Document";
    ProofOfRightsTypeEnum["Url"] = "Url";
})(ProofOfRightsTypeEnum || (ProofOfRightsTypeEnum = {}));
var ProofOfRightsContentTypeEnum;
(function (ProofOfRightsContentTypeEnum) {
    ProofOfRightsContentTypeEnum["Samples"] = "Samples";
    ProofOfRightsContentTypeEnum["LicensedInstrumentalOrBeat"] = "LicensedInstrumentalOrBeat";
    ProofOfRightsContentTypeEnum["RemixedContent"] = "RemixedContent";
    ProofOfRightsContentTypeEnum["StockSoundsOrLoops"] = "StockSoundsOrLoops";
    ProofOfRightsContentTypeEnum["Other"] = "Other";
})(ProofOfRightsContentTypeEnum || (ProofOfRightsContentTypeEnum = {}));

export { ProofOfRightsContentTypeEnum, ProofOfRightsTypeEnum };
